declare const __VERSION__: string;

export const APP_NAME = 'backtrace-js';
export const VERSION = __VERSION__;
export const USER_AGENT = navigator.userAgent;
export const LANG = 'js';
export const THREAD = 'main';
